module.exports = __webpack_public_path__ + "img/zip.6da81f5e.svg";